module.exports = __webpack_public_path__ + "fontawesome-webfont.a3de2170e4e9df77161e.ttf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Partners-Pipeline/src/assets/fonts/font-awesome/fontawesome-webfont.ttf?v=4.5.0
// module id = ../../../../../src/assets/fonts/font-awesome/fontawesome-webfont.ttf?v=4.5.0
// module chunks = styles